const sizesModel = vm => ({
  title: vm.$gettext('Sizes'),
  endpoint: 'sizes',
  allowNew: true,
  shared: 'semi',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Real World™ reference objects to exemplify the size.')
    },
    {
      key: 'max_length',
      label: vm.$gettext('Max. Length'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Max length allowed in centimeters.')
    },
    {
      key: 'max_width',
      label: vm.$gettext('Max. Width'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Max width allowed in centimeters.')
    },
    {
      key: 'max_height',
      label: vm.$gettext('Max. Height'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Max height allowed in centimeters.')
    },
    {
      key: 'max_weight',
      label: vm.$gettext('Max. Weight'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Max weight allowed in grams.')
    }
  ],
  filters: ['id', 'name', 'reference']
})

export default sizesModel
